<template>
  <v-card>
    <v-card-title>
      <v-icon left>{{ icon }}</v-icon>
      {{ title }}
      <v-spacer />
      <v-progress-circular v-if="loading"
        indeterminate :size="20" :width="1"
        :color="themes.client.light.input"
      />
      <v-icon v-else-if="value !== null">{{ value }}</v-icon>
      <v-icon v-else>{{ placeholder }}</v-icon>
    </v-card-title>
    <v-divider />
    <v-card-text class="py-2">
      <div class="caption grey--text text--darken-1">
        <v-icon small>mdi-information-variant</v-icon>
        {{ info }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: [
    'icon',
    'title',
    'path',
    'info',
    'placeholder'
  ],
  data: () => ({ loading: true, value: null }),
  created() {
    Vue.$http
      .get(this.path)
      .then(({ data }) => this.value = data)
      .finally(() => (this.loading = false))
  }
}
</script>
